import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderSubject = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   * Show loader
   */
  show(): void {
    this.loaderSubject.next(true);
  }

  /**
   * Hide loader
   */
  hide(): void {
    this.loaderSubject.next(false);
  }

  /**
   * Get loader status
   */
  getLoaderStats(): Observable<boolean> {
    return this.loaderSubject.asObservable();
  }

  /**
   * Get current loader status (sync)
   */
  isLoading(): boolean {
    return this.loaderSubject.value;
  }
}
